import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {DateAdapter} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {MemberService} from 'src/app/services/member.service';
import {SitePublicService} from 'src/app/services/site-public.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

@Component({
  selector: 'app-directors-period-dialog',
  templateUrl: './directors-period-dialog.component.html',
  styleUrls: [ './directors-period-dialog.component.scss' ]
})
export class DirectorsPeriodDialogComponent implements OnInit {

  public directors$!: Observable<any[]>;
  public directors: any = [];

  public roles: any;
  public title: string = "";

  public roleForm: FormGroup;
  public members: any[] = []

  constructor (
    public matDialogRef: MatDialogRef<DirectorsPeriodDialogComponent>,
    private _adapter: DateAdapter<any>,
    private _sitePublicService: SitePublicService,
    private fb: FormBuilder,
    private _memberService: MemberService,
    private _snackBar: SnackBarIconService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //console.log("dialog data: " + JSON.stringify(this.data));
    this.title = this.data.period

    this.initializeAutoCompletes(this.data);
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this.getRoles();
    this.getDirectors();
  }

  async getRoles () {
    this.roles = await this._sitePublicService.getDirectorsRoles();
    // console.log("roles>: " + JSON.stringify(this.roles))
  }

  async getDirectors () {
    this.directors$ = this._sitePublicService.selectBienniumDirectors(this.data.id);
    // Opcional: Se precisar fazer algo com os dados além de exibi-los
    this.directors$.subscribe(directors => {
      //console.log("directors updated:", directors);
    });
  }

  getData () {
    const formData = this.roleForm.getRawValue();
    const id = formData.id;
    const data = {
      'position': formData.role.position,
      'role_id': formData.role.id,
      'role_name': formData.role.name,
      'member_id': formData.member.id,
      'member_name': formData.member.name,
      'member_state': formData.member.state,
      'member_text': formData.member.text,
      'member_image': formData.member.image,
    }

    this._sitePublicService.insertBienniumDirector(id, data)
      .then((result) => {
        this._snackBar.openSnackBar("Sucesso!", '', 'success')
      })
      .catch((err) => {
        this._snackBar.openSnackBar("Erro!", '', 'error')
      })


  }

  directorView (element) {
    console.log(JSON.stringify(element))
  }

  removeDirector (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.member_name + "<br><br>Excluir este diretor?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        
        this._sitePublicService.deleteBienniumDirector(this.data.id, element.id)
          .then(() => {
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch((err) => {
            this._snackBar.openSnackBar("Erro!", '', 'error')
          })

      }
    })
  }

  //
  // AUTOCOMPLETES //////////////////

  initializeAutoCompletes (data) {

    this.roleForm = this.fb.group({
      id: new FormControl(data.id),
      role: new FormControl(data.role_id),
      //role_name: new FormControl(data.role_name),
      member: new FormControl(data.member_name),
    });

    this.roleForm.controls.member.valueChanges.subscribe(val => {
      if (val != undefined) this.updateMemberSearchList(val);
    })
  }

  cleanMemberSearch () {
    this.members = []
  }

  updateMemberSearchList (val) {

    if (val.length > 3) {
      this._memberService.selectStaffStartAt(val)
        .subscribe((result) => {

          this.members = []

          result.forEach((item) => {

            const deleted = item.data().deleted ? true : false

            if (!deleted) {

              this.members.push({
                "id": item.id,
                "name": item.data().name,
                "state": item.data().state,
                "image": item.data().image,
                "text": item.data().text
              })

            }

          })

        })
    }
  }

  displayMember (value) {

    if ((value !== null) && (value !== undefined) && (value !== "")) {
      return value.name;
    } else {
      return "";
    }

  }



}
